<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'App',
        data() {
            return {}
        },
        async created () {
            await this.init();
        },
        async mounted() {
            await this.getSystemInfo();
        },
        methods: {
            async init(){
                console.log('当前账户---------->', this.$store.state.account);
                if(!this.$store.state.account || !localStorage.getItem('account')){
                    return this.$router.replace({
                        name: 'login'
                    });
                }
                // return await this.$socket.init({uuid: this.$store.state.account.deviceCode});
            },
            async getSystemInfo(){                
                if (window.ynznAppInfo && typeof window.ynznAppInfo.getSerialNumber === 'function') {
                    try {
                        const deviceUuid = await window.ynznAppInfo.getSerialNumber();
                        this.$store.commit('initDeviceUuid', deviceUuid);
                        console.log('设备信息uuid:', deviceUuid);  
                    } catch (error) {
                        console.error('获取设备信息失败:', error)
                    }
                }               
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue